import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import apiMiddleware from './middleware/api'

import rootReducer from './reducers'

const loggerMiddleware = createLogger()

export default function configureStore (preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(
      thunkMiddleware,
      apiMiddleware,
      loggerMiddleware
    )
  )
}
